import { NEW_EXISTING_RADIO_STATE_KEY } from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';

import { getThemeParameters } from '../../../../config/theme/selector';
import { SearchParameterToQuery } from '../../../../Search/constants';
import { getProfilePageParameters } from '../../state/selectors';
import isZocdocBrand from '../../../../utils/isZocdocBrand';

export default function mapStateToProps(state) {
    const themeParameters = getThemeParameters(state);
    const profilePageParams = getProfilePageParameters(state);
    const {
        reason_visit: procedureId,
        referrerType,
        widget,
    } = profilePageParams;
    const is1Z = isZocdocBrand(themeParameters.directoryId);
    const { isNewPatient } = (is1Z ? profilePageParams : state[NEW_EXISTING_RADIO_STATE_KEY]);

    return {
        is1Z,
        practiceParameters: {
            [SearchParameterToQuery.procedureId]: procedureId,
            isNewPatient,
            referrerType,
            widget,
        },
        showInstitutes: themeParameters.profile.showInstitutes,
        usePracticeLinks: themeParameters.profile.showPracticeLinks,
    };
}
